/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Page_SubtitleInputs */



/**
* | output |
* | --- |
* | "Your personal personas plus the ones shared across your organization." |
*
* @param {Personas_Page_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_page_subtitle = /** @type {((inputs?: Personas_Page_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Page_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deine persönlichen Personas und die in deiner Organisation geteilten.")
	return /** @type {LocalizedString} */ ("Your personal personas plus the ones shared across your organization.")
});